import * as React from "react";

import "./credits-section.scss";

import {cs}    from "@Common/react/chain-services";
import {keyed} from "@Common/react/keyed";

import {groupSections} from "../common/group-sections";

import {Copay}        from "./copay/copay";
import {OtherCredits} from "./other-credits/other-credits";
import {isDevQuan} from "@Common/ui-components/debug/is-dev-quan";

export const CreditsSection = ({store, next}) => cs(

    ["sections", ({}, next) => cs(
        ["copay", (_, next) => Copay({
            store,
            next,
        })],
        ["otherCredits", ({}, next) => OtherCredits({
            store,
            next,
        })],
        ({copay, otherCredits}) => next([
            !isDevQuan() && copay,
            otherCredits,
        ].filter(v=>v)),
    )],

    ({sections}) => next({
        ...groupSections(sections),
        render: () => {
            if (!sections.find((s) => s.available)) {
                return null;
            }

            return (
                <div className="credits credits-section-67n">
                    <div className="header">
                        <div className="title" xd-qa-type="label" xd-qa-name="Credits">
                            Credits
                        </div>
                    </div>

                    {sections.map((section,i ) => cs(
                        keyed(i),
                        () => section.available && section.render({
                            className: "card",
                        })
                    ))}
                </div>
            );
        },
    }),
);

